import { Badge, Box, Checkbox, Group, Stack, Text } from '@mantine/core';

const CheckboxCell = ({ cell, label, accessorKey, onChange, disabled }) => {
    const { column, row } = cell;
    const rowData = row.original;
    const value = rowData[accessorKey];
    return (
        <Checkbox
            label={label}
            defaultChecked={value}
            onChange={
                onChange
                    ? (e) => {
                          onChange(rowData, e.currentTarget.checked, e);
                      }
                    : null
            }
            disabled={disabled}
        />
    );
};

const CheckboxColumn = ({ id, header, accessorKey, onChange, disabled }) => ({
    id: id || accessorKey,
    accessorKey: accessorKey,
    header: header,
    size: 2,
    minSize: 40,
    Cell: ({ cell }) => (
        <CheckboxCell
            cell={cell}
            accessorKey={accessorKey}
            onChange={onChange}
            disabled={disabled}
        />
    ),
});
export default CheckboxColumn;
